module.exports = __webpack_public_path__ + "static/nonGmo-b6ed79807a871fa8bf81dd0651a6273c.png";